import withMobileDetection from './WithMobileDetection';

export default withMobileDetection;
export type { WithMobileDetectionProps } from "./WithMobileDetection";
